import contract from './sessionProcessingContract.json'

export const SESSION_PROCESSING_CONTRACT = contract

export const VERSION_KEY_PATTERN = new RegExp(contract.versionKeyPattern)
